// extracted by mini-css-extract-plugin
module.exports = {"confirmation":"index_confirmation__1jTJY","title":"index_title__GslbW","content":"index_content__1oCJ8","select":"index_select__1ICBX"};